//LIST_EXPERIENCE
export const listExperience = (
    experience = []
) =>({
    type: 'LIST_EXPERIENCE',
    experience
});


// WEBPACK FOOTER //
// ./src/actions/experience.js